import React, { useState } from 'react'
import { DropdownPillSyncProps } from 'components/common/dropdown_pill/DropdownPill'

interface ReviewFiltersProps {
  dropdownFilters: React.ReactElement[]
}

type IdState = string | null

export const ReviewFilters: React.FC<ReviewFiltersProps> = ({ dropdownFilters }) => {
  const [expandedFilterKey, setExpandedFilterKey] = useState<IdState>(null)

  const handleShouldOpen = (id: IdState): void => {
    setExpandedFilterKey(id)
  }

  const handleShouldClose = (_id: IdState): void => {
    setExpandedFilterKey(null)
  }

  // Inject handlers and id into review filters.
  // Note that if the review filter is not a Dropdown component,
  // then it must pass the injected props down to the dropdown component
  const reviewFilters = dropdownFilters?.map((filter, index) => {
    const { id } = filter?.props
    const filterId = id ?? `${index}`
    const isExpanded = expandedFilterKey === filterId
    const onClick = isExpanded ? handleShouldClose : handleShouldOpen
    const syncProps: DropdownPillSyncProps = {
      id: filterId,
      isExpanded,
      onClick
    }
    return React.cloneElement(filter, { ...syncProps })
  })

  return (
    <div className='review-filters'>
      {reviewFilters}
    </div>
  )
}
